import { Container, ContainerHeader, ContainerContent } from 'components/Containers/Containers'
import { CheckableList } from 'components/CheckableList/CheckableList'
import { HonestSelectAsyncInput } from 'components/HonestAsyncSelect/HonestAsyncSelectInput'
import { ISelectValue } from 'constants/globalTypes'
import { Flex } from 'styling/GlobalStyles'
import { Button } from 'components/ui/Button/Button'
import { TitleText } from 'styling/Typography'
import { parseLocationRegistryOptions } from 'features/locationRegistry/locationRegistryMappers'
import { IShiftProgramState } from 'types/operationShiftPrograms.interface'
import { toast } from 'react-toastify'

export const Scope = ({ setStep, setState, state }: { setStep: (step: number) => void, setState?: any, state: IShiftProgramState }) => {


    const handleSelect = (value: ISelectValue, name: string) => {
        setState((prev: IShiftProgramState) => ({ ...prev, [name]: value, teams: name == 'site' ? [] : prev.teams }))
    }
    const handleTeamsChange = (teams: ISelectValue[]) => {
        setState((prev: IShiftProgramState) => ({ ...prev, teams }))
    }
    const parseTeams = (data: any) =>
        data?.data?.map((team: any) => ({ label: team.name, value: team.id })) ?? []

    const handleNext = () => {

        if (!state.site?.value) {
            toast.warn('Site is required')
            return
        }
        setStep(3)


    }
    const handleBack = () => setStep(1)

    return <>


        <Container>
            <ContainerHeader>
                <TitleText>Org Scope</TitleText>
            </ContainerHeader>
            <ContainerContent>
                <Flex gap='1rem' mb='16'>
                    <HonestSelectAsyncInput
                        nomarg
                        link='locations'
                        placeholder='Search sites'
                        name='site'
                        labelText='Site'
                        defaultValue={state?.site?.label}
                        onChange={handleSelect}
                        parserFunction={parseLocationRegistryOptions}
                        required
                        invalid={!state.site?.value}
                    />
                </Flex>
                <CheckableList
                    link='operational/management/team'
                    additionalParams={state?.site?.value ? { siteIds: state.site.value } : undefined}
                    parserFunction={parseTeams}
                    searchEnabled
                    searchPlaceholder='Search teams...'
                    selected={state.teams ?? []}
                    onChange={handleTeamsChange}
                    selectedLabelText='Selected teams'
                    selectedPlaceholder='No teams selected'
                    listMaxHeight='16rem'

                />

            </ContainerContent>
        </Container>
        <Flex gap='1rem' mt='32' justend>
            <Button variant='secondary' onClick={handleBack}>Back</Button>
            <Button variant='primary' onClick={handleNext} >Next</Button>
        </Flex>
    </>
}
